import React from 'react';
import cx from 'classnames';
import { useTranslations } from '@unisporkal/localization';
import { useTheme } from '@unisporkal/themes';
import { RawHtml } from '@unisporkal/utilities';
import { useSiteMap } from '@unisporkal/sites';
import useDownloadModifiedAsset from '../../../../hooks/useDownloadModifiedAsset';
import { useAsset } from '../../../../hooks/stateful/useAsset';
import styles from '../Messages.module.scss';

interface EasyAccessCompMessageProps {
  isAgencyUnlimitedPilot?: boolean;
}

const EasyAccessCompMessage: React.FC<EasyAccessCompMessageProps> = ({
  isAgencyUnlimitedPilot = false,
}) => {
  const { asset } = useAsset();
  const t = useTranslations();
  const siteMap = useSiteMap();
  const { genId } = useDownloadModifiedAsset();
  const theme = useTheme();
  const themeLink = theme.link || {};
  const marketFreezeLink = siteMap.eloquaMarketFreezeContactUsUrl(asset.id);

  const isModified = !!genId;

  return (
    <>
      <div
        className={styles.buyCardMessage}
        data-testid="easy-access-comp-message"
      >
        {isAgencyUnlimitedPilot ? t('eza_comps_intro') : t('eza_comps_message')}
      </div>
      {asset.isRoyaltyFree() && !isModified ? (
        <div
          className={cx(styles.buyCardMessage, themeLink.textLink)}
          data-testid="eza-comp-market-freeze-message"
        >
          <RawHtml>
            {t('eza_comp_market_freeze_message', {
              links: [
                {
                  href: marketFreezeLink,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  id: 'marketFreezeLink',
                },
              ],
            })}
          </RawHtml>
        </div>
      ) : null}
    </>
  );
};

export default EasyAccessCompMessage;
